(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sale-countdown"] && !Shopify.designMode) return;
  try {
    class CollectionDealCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const endTimeStr = this.dataset.dealEnd;
    if (!endTimeStr) return;

    const endTime = new Date(endTimeStr).getTime();

    this.innerHTML = `
      <div class="sale-countdown-timer">
        <span class="collection-deal-countdown__sale-text">SALE ENDS IN</span>
        <span class="collection-deal-countdown__separator"></span>
        <span class="collection-deal-countdown__time" data-time-unit="days">00 Days</span>
        <span class="collection-deal-countdown__mobile-separator"></span>
        <span class="collection-deal-countdown__separator"></span>
        <span class="collection-deal-countdown__time" data-time-unit="hours">00 Hours</span>
        <span class="collection-deal-countdown__separator"></span>
        <span class="collection-deal-countdown__mobile-separator"></span>
        <span class="collection-deal-countdown__time" data-time-unit="minutes">00 Minutes</span>
        <span class="collection-deal-countdown__separator"></span>
        <span class="collection-deal-countdown__time" data-time-unit="seconds">00 Seconds</span>
      </div>
    `;

    const daysEl = this.querySelector('[data-time-unit="days"]');
    const hoursEl = this.querySelector('[data-time-unit="hours"]');
    const minutesEl = this.querySelector('[data-time-unit="minutes"]');
    const secondsEl = this.querySelector('[data-time-unit="seconds"]');

    const pad = (num) => num.toString().padStart(2, '0');

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        this.remove();
        clearInterval(this.intervalId);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = `${pad(days)} Days`;
      if (hoursEl) hoursEl.textContent = `${pad(hours)} Hours`;
      if (minutesEl) minutesEl.textContent = `${pad(minutes)} Minutes`;
      if (secondsEl) secondsEl.textContent = `${pad(seconds)} Seconds`;
    };

    updateCountdown();
    this.intervalId = setInterval(updateCountdown, 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}

customElements.define('collection-deal-countdown', CollectionDealCountdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown-banner"] && !Shopify.designMode) return;
  try {
    class CollectionCountdownBanner extends HTMLElement {
  constructor() {
    super();

    this.desktopInsertIndex = 6;
    this.mobileInsertIndex = 4;
  }

  connectedCallback() {
    this.observePage();
    this.moveBanner();
  }

  observePage() {
    const observer = new MutationObserver(() => {
      const grid = this.getGrid();
      if (!grid) return;

      const products = this.getProducts(grid);
      const index = this.getInsertIndex();
      const reference = products[index - 1];

      if (!reference || this.previousElementSibling === reference) return;

      observer.disconnect();
      this.moveBanner();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });
  }

  getGrid() {
    return document.querySelector('ul.product-grid[ref="grid"]');
  }

  getProducts(grid) {
    return [...grid.querySelectorAll(".product-grid__item")];
  }

  getInsertIndex() {
    return window.matchMedia("(min-width: 990px)").matches
      ? this.desktopInsertIndex
      : this.mobileInsertIndex;
  }

  moveBanner() {
    const grid = this.getGrid();
    if (!grid) return;

    const products = this.getProducts(grid);
    const index = this.getInsertIndex();

    if (products.length < index) {
      this.remove();
      return;
    }

    if (products.length < index) return;

    const reference = products[index - 1];

    if (this.previousElementSibling === reference) return;

    reference.after(this);

    this.initCountdown();
  }

  initCountdown() {
    if (window.helpers?.initCollectionDealCountdown) {
      window.helpers.initCollectionDealCountdown();
    }
  }
}

customElements.define("collection-countdown-banner", CollectionCountdownBanner);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    function updateInfiniteLoader() {
      const grid = document.querySelector('[ref="grid"]');
      const loader = document.querySelector('[ref="viewMoreNext"]');

      if (!grid || !loader) return;

      const lastPage = Number(grid.dataset.lastPage);

      const cards = grid.querySelectorAll('[data-page]');
      if (!cards.length) return;

      const lastCard = cards[cards.length - 1];
      const currentPage = Number(lastCard.dataset.page);

      if (currentPage >= lastPage) {
        loader.classList.add('is-hidden');
      } else {
         loader.classList.remove('is-hidden');
      }
    }

    document.addEventListener('DOMContentLoaded', updateInfiniteLoader);

    const observer = new MutationObserver(() => {
      updateInfiniteLoader();
    });

    function startObserving() {
      const grid = document.querySelector('[ref="grid"]');
      if (!grid) return;

      observer.observe(grid, {
        childList: true,
        subtree: false,
      });
    }

    document.addEventListener('DOMContentLoaded', startObserving);
  })();

  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.scrollToTop = this.scrollToTop.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.scrollToTop);
      this.toggleVisibility = this.toggleVisibility.bind(this);
      window.addEventListener('scroll', this.toggleVisibility);
      this.toggleVisibility();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.scrollToTop);
      window.removeEventListener('scroll', this.toggleVisibility);
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    toggleVisibility() {
      if (window.scrollY > 200) {
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      } else {
        this.style.opacity = '0';
        this.style.pointerEvents = 'none';
      }
    }
  }

  customElements.define('back-to-top', BackToTop);
  } catch(e) { console.error(e); }
})();

})();
